import type { OptionType } from "components/inputs";
import type { ClaimantType } from "types/DataTypes";

export const getVerboseFileStatus = (status: string): string => {
  if (status === "O") {
    return "Opened";
  } else if (status === "C") {
    return "Completed";
  } else {
    return "Unprocessed";
  }
};

export const getVerboseServiceStatus = (status: string): string => {
  if (status === "P") {
    return "Pending";
  } else if (status === "IN") {
    return "In progress";
  } else {
    return "Complete";
  }
};

/* currency formatting */
export const formatCurrency = (amount: number | string | null | undefined) => {
  if (amount == null) return "$0.00";
  // ensure we're working with a number with 2 decimal precision
  const numericAmount = Number(parseFloat(amount.toString()).toFixed(2));
  if (Number.isNaN(numericAmount)) return "$0.00";
  return `$${numericAmount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/* Claimant Dropdown Label */
export const formatClaimantLabel = (claimant: ClaimantType): string => {
  const name = [claimant.last_name, claimant.first_name, claimant.middle_name]
    .filter(Boolean)
    .join(", ");

  const parts = [name];

  if (claimant.birth_date && claimant.gender) {
    parts.push(`DOB: ${claimant.birth_date} - ${claimant.gender}`);
  } else if (claimant.birth_date) {
    parts.push(`DOB: ${claimant.birth_date}`);
  }

  if (claimant.ssn) {
    parts.push(`SSN: ${claimant.ssn}`);
  }

  return parts.join("\\n");
};

export const formatOptionLabel = (
  option: OptionType,
  context: { context: string },
  isCreateClaimant?: boolean,
): React.ReactNode => {
  const [name, dob, ssn] = option.label.split("\\n");

  if (isCreateClaimant && option.label === "Create a Claimant") {
    return name;
  } else if (context.context === "menu") {
    return (
      <div>
        <span>{name}</span>
        <span>{dob}</span>
        <span>{ssn}</span>
      </div>
    );
  }

  const ssnValue = ssn?.replace("SSN: ", "") || "";
  // sometimes the ssn is not available, so we just show the name
  return ssnValue ? `${name} (${ssnValue})` : name;
};

export const selectStyles = {
  option: (provided: Record<string, unknown>) => ({
    ...provided,
    whiteSpace: "pre-line",
    "& span": {
      display: "block",
      "&:not(:first-child)": {
        color: "#6B7280",
        fontSize: "0.6rem",
      },
    },
  }),
};
